<template>
  <div class="w-full">
    <component
      :is="componentByType[type]"
      v-show="!hidden.includes(question_id)"
      :question="question"
      :subject="subject"
      :question_id="question_id"
      :onboarding-packet-id="onboardingPacketId"
      :set-onboarding-packet="setOnboardingPacket"
      :toggle-required="toggleRequired"
      :required="required"
      :conditional_children="children"
      @child-check="checkShowChild"
    >
      <tool-tip
        v-if="question.tooltip"
        color-scheme="dark"
        :content="question.tooltip"
        class="relative"
        style="top: 1.5px"
      >
        <div>{{ question.tooltip }}</div>
      </tool-tip>
    </component>
  </div>
</template>

<script>
import { shallowRef } from 'vue';

import ToolTip from '@/components/ToolTip.vue';
import TextArea from './Type/TextArea.vue';
import Radio from './Type/Radio.vue';
import CustomRadio from './Type/CustomRadio.vue';
import Checkbox from './Type/Checkbox.vue';
import Input from './Type/Input.vue';
import TextInput from './Type/TextInput.vue';
import Select from './Type/Select.vue';
import Date from './Type/Date.vue';
import File from './Type/File.vue';
import Attestation from './Type/Attestation.vue';

const textAreaRef = shallowRef(TextArea);
const radioRef = shallowRef(Radio);
const customRadioRef = shallowRef(CustomRadio);
const checkboxRef = shallowRef(Checkbox);
const inputRef = shallowRef(Input);
const textInputRef = shallowRef(TextInput);
const selectRef = shallowRef(Select);
const dateRef = shallowRef(Date);
const fileRef = shallowRef(File);
const attestationRef = shallowRef(Attestation);

// import { objectToFormData } from '@/common/json';

import Compare from 'expr-eval';
const Parser = Compare.Parser;

export default {
  name: 'DynamicQuestion',
  components: {
    ToolTip,
  },
  props: {
    item: Object,
    toggleRequired: Function,
    hidden: Array,
  },
  emits: ['hide', 'unhide'],
  data() {
    return {
      answer: '',
      question: '',
      id: null,
      question_id: null,
      required: null,
      type: null,
      onboardingPacketId: null,
      componentByType: {
        input_string: textInputRef,
        textarea: textAreaRef,
        radio: radioRef,
        checkbox: checkboxRef,
        input_integer: inputRef,
        input_float: inputRef,
        input_date: dateRef,
        select: selectRef,
        file: fileRef,
        file_multiple: fileRef,
        jb_hunt_factor_office: customRadioRef,
        attestation: attestationRef,
      },
      parents: [],
      children: [],
    };
  },
  computed: {
    subject() {
      return this.question?.subject + (this.required ? ' (Required)' : '');
    },
  },
  watch: {
    item() {
      this.setQuestionData();
    },
  },
  mounted() {
    this.setQuestionData();
  },
  methods: {
    setQuestionData() {
      let { id, is_required, question, company_question_conditions } =
        this.item;
      this.id = id;
      this.required = is_required;
      this.question = question;
      this.question_id = id;
      this.type = question?.is_type;
      this.onboardingPacketId =
        this.$store.state.onboardingPacket.onboarding_id;
      this.parents = company_question_conditions?.parents || [];
      this.children = company_question_conditions?.children || [];
    },
    async setOnboardingPacket(body) {
      let currentPacket =
        this.$store.state.onboardingPacket.onboardingPacketBody
          ?.onboarding_packet?.answers_attributes;
      let updatedBody = [body];
      if (currentPacket) {
        let filteredPacket = currentPacket.filter(
          (el) => el?.company_question_id !== this.question_id
        );
        updatedBody = [...updatedBody, ...filteredPacket];
      }

      let onboardingPacketBody = {
        onboarding_packet: {
          answers_attributes: updatedBody,
        },
      };

      await this.$store.dispatch(
        'onboardingPacket/setOnboardingBody',
        onboardingPacketBody
      );
    },
    checkShowChild(
      question_id,
      answer,
      predicate,
      is_shown_by_default,
      is_required
    ) {
      console.log('checkShowChild: value == ' + answer);
      const parser = new Parser();
      let expr = parser.parse(predicate);
      let result = expr.evaluate({ value: answer });
      if (result == true && this.hidden.includes(question_id)) {
        this.$emit('unhide', question_id);
      } else if (result == false && !this.hidden.includes(question_id)) {
        this.$emit('hide', question_id, is_shown_by_default, is_required);
      }
    },
  },
};
</script>
